<template>
    <div style="margin-left:12.5%;margin-right:12.5%;background-color:#ffffff;border:1px solid #eeeeee;">
        <div style="border-bottom: 1px solid #eeeeee;height:22px;padding:20px;">
            <div style="text-align:left;height:20px;line-height:20px;">
                <div style="float:left;"><img src='../assets/return.png' style="width:10px;" /></div>
                <div style="float:left;margin-left:10px;"><a href="#" @click.prevent="goBack" style="text-decoration:none;color:#333333;">返回评估列表</a></div>
                <div style="float:left;margin-left:200px;">
                    <span style="color:#42b6ff;" v-if="opt_type=='eval' || status!='已提交'">正在评估：</span>
                    <span style="color:#42b6ff;" v-else>查看评估：</span>
                    <span>{{ task_name }}</span>
                </div>            
            </div>
        </div>
        <div style="margin-top:17px;padding:0 20px;">
            <div style="text-align:left;">
                <span>被评估人：</span>
                <span style="color:#ffaa2c;">{{ assessee_name }}</span>
                <span style="margin-left:200px;">评估类型：</span>
                <span style="color:#ffaa2c;">{{ task_type }}</span>
            </div>
            <div style="margin-top:17px;background:#f6fcff;padding:15px;color:#aaaaaa;text-align:left;" v-if="task_type=='工作动机重要性及满意度评估' && status!='已提交'">
                <span v-if="is_superior=='是'">请您仔细回忆与下属 <span style="color:#ffaa2c;">{{ assessee_name }}</span> 的日常沟通以及激励方式，选出在您看来下属 <span style="color:#ffaa2c;">{{ assessee_name }}</span> 对以下工作动机的重要程度和满意程度。</span>
                <span v-else>请填写以下表格，打勾选出对上级沟通方式及协作行为感知的重要程度和满意程度。</span>
            </div>
            <div style="margin-top:17px;background:#f6fcff;padding:15px;color:#aaaaaa;text-align:left;" v-else-if="task_type=='下属离职倾向识别' && status!='已提交'">
                <span>请您仔细回忆下属 <span style="color:#ffaa2c;">{{ assessee_name }}</span> 的近期行为表现，对是否出现过以下行为做出判断（尤其关注之前没有类似行为，在近期突然出现的异常行为）。</span>
            </div>
            <div style="margin-top:17px;background:#f6fcff;padding:15px;color:#aaaaaa;text-align:left;" v-else-if="task_type=='激励资源评估' && status!='已提交'">
                <span v-if="is_superior=='否'">对于以下激励资源，请填写您上级的使用频率。</span>
                <span v-else>对于以下激励资源，请填写您本人的使用频率。</span>
            </div>
            <div style="margin-top:17px;background:#f6fcff;padding:15px;color:#aaaaaa;text-align:left;" v-else-if="task_type=='组织健康度调研（A卷）' && status!='已提交'">
                <span>公司的健康成长和良性发展离不开每一位同学的努力和关注，邀请您仔细阅读并回答每个题目，虽然有一些题目看起来似乎与您所在的团队无关，但它们对于公司的组织健康度提升非常重要，请您结合您的客观判断，给出答案。</span><br>
                <span style="font-weight:bold;color:#ffaa2c;">本次调研完全匿名，严格保密，请放心填写。</span><br><br>
                <!-- 20231224 增加问卷条件说明 -->
                <span>填写说明：</span><br>
                <span>- 选择题为必选题，举证题为可选题。</span><br>
                <span v-if="low_score_num">- 选择题中包含3分（对应选项“基本不认可”）及以下结果的最低数量为{{ low_score_num }}。<br></span>
                <span v-if="continuous_num">- 选择题中连续选择相同答案的数量为{{ continuous_num }}。<br></span>
            </div>
            <div style="margin-top:17px;background:#f6fcff;padding:15px;color:#aaaaaa;text-align:left;" v-else-if="(task_type=='管理痛点调研（B卷）'||task_type=='管理痛点献计献策（C卷）'||task_type=='管理痛点调研（D卷）') && status!='已提交'">
                <span>“三个臭皮匠，顶个诸葛亮”，我们希望大家为公司献计献策、共谋发展，帮助识别公司的经营管理问题，分析背后可能的原因，提供解决思路，不断提升组织健康度，助力业务突破。同时，也借助于这个机会，展示各位同学对公司问题的敏感度、思考和解决问题的深度，希望大家认真作答！</span>
            </div>
            <div style="margin-top:17px;background:#f6fcff;padding:15px;color:#aaaaaa;text-align:left;" v-else-if="task_type!='管理痛点调研' && opt_type=='eval'">
                <span>欢迎您进入管理基本功测评系统。</span><span style="color:#ffaa2c;font-weight:bold;">本测评结果会严格匿名保密，且不涉及任何晋升与奖惩，结果并无好坏对错之分，是一次管理成熟度照镜子的过程。</span><span>您只需要根据被评估人日常工作管理行为进行评分即可。自评环节帮助您反思和觉察自己的领导力行为，他评环节基于周边360度角色，帮助您作评估对比参考。请避免出现全部选项打分一样的情况。</span><br><br>
                <span style="color:#ffaa2c;">只需要15分钟，即可完成您的评测之旅。</span>
            </div>
        </div>
        <!-- 这里通过sendData监听子组件的$emit方法，并通过父组件的getData方法获取子组件传递的数据 -->
        <survey-mana 
        ref="survey_mana" 
        @sendData="getSurveyResults" 
        :survey_info="survey_info" 
        :error_flag_survey="error_flag_survey" 
        v-if="task_type=='管理痛点调研'">
        </survey-mana>
        <motiv-mana 
        ref="motiv_mana" 
        @sendData="submitMotivationResults"  
        :error_flag="error_flag"
        :submit_times="submit_times"
        :is_view="status=='已提交'"
        v-else-if="task_type=='工作动机重要性及满意度评估'">
        </motiv-mana>
        <behav-mana 
        ref="behav_mana" 
        @sendData="submitBehaviorResults" 
        :behavior_info="behavior_info" 
        :error_flag="error_flag"
        :submit_times="submit_times"
        :is_view="status=='已提交'"
        v-else-if="task_type=='下属离职倾向识别'">
        </behav-mana>
        <resour-mana 
        ref="resour_mana" 
        @sendData="submitResourceResults" 
        :resource_info="resource_info" 
        :error_flag_resource="error_flag_resource"
        :submit_times="submit_times"
        :is_view="status=='已提交'"
        v-else-if="task_type=='激励资源评估'">
        </resour-mana>
        <jiankang-mana 
        ref="jiankang_mana" 
        @sendData="getJKQuesResults" 
        :question_info="jk_question_info" 
        :proof_info="jk_proof_info" 
        :error_flag="error_flag"
        :submit_times="submit_times"
        :is_view="status=='已提交'"
        v-else-if="task_type=='组织健康度调研（A卷）'">
        </jiankang-mana>
        <tongdian-mana 
        ref="tongdian_mana" 
        @sendData="getTDQuesResults" 
        :painspot_info="painspot_info" 
        :ques_type="ques_type" 
        :error_flag="error_flag" 
        :sys_params="sys_params" 
        :selected_painspots="selected_painspots" 
        :is_view="status=='已提交' || status=='已反馈'"
        v-else-if="task_type=='管理痛点调研（B卷）' || task_type=='管理痛点献计献策（C卷）' || task_type=='管理痛点调研（D卷）'">
        </tongdian-mana>
        <quesmana ref="ques_mana" 
        @sendData="getQuesResults" 
        :question_info="question_info" 
        :proof_info="proof_info" 
        :error_flag="error_flag" 
        v-else>
        </quesmana>       
        <!-- 按钮的显示，增加一个question_info.length的条件，只有当问卷加载成功后才显示，防止一闪的时候显示按钮 -->
        <div style="text-align:center;margin-bottom:80px;" v-if="((task_type=='管理痛点调研' && survey_info.length > 0) || (task_type!='管理痛点调研' && question_info.length > 0)) && opt_type=='eval'">
            <el-button type="primary" @click="dialogSubmit">提 交</el-button>
            <el-button @click="dialogCancel">取 消</el-button>          
        </div>
        <div style="text-align:center;margin-bottom:80px;" v-if="(status=='未开始' || status=='未提交') && task_type=='组织健康度调研（A卷）' && jk_question_info.length > 0">
            <el-button @click="dialogCancel_jk">取 消</el-button>
            <el-button type="primary" @click="dialogSubmit_jk">提 交</el-button>
        </div>
        <div style="text-align:center;margin-bottom:80px;" v-if="(status=='未开始' || status=='未提交') && (task_type=='管理痛点调研（B卷）' || task_type=='管理痛点献计献策（C卷）' || task_type=='管理痛点调研（D卷）') && painspot_info.length > 0">
            <el-button @click="dialogCancel_ps">取 消</el-button>
            <el-button type="primary" @click="dialogSubmit_ps">提 交</el-button>
        </div>
        <div style="text-align:center;margin-bottom:80px;" v-if="(status=='未开始' || status=='进行中') && ((task_type=='下属离职倾向识别' && behavior_info.length > 0) || (task_type=='激励资源评估' && resource_info.length > 0) || task_type=='工作动机重要性及满意度评估')">
            <el-button @click="dialogSave_rc" :disabled="submit_status">保 存</el-button>
            <el-button type="primary" @click="dialogSubmit_rc" :disabled="submit_status">提 交</el-button>
        </div>
    </div>
</template>

<script>
import quesmana from "./QuestionManagement/ChengShu_quesmana.vue";
import surveyMana from "./QuestionManagement/ChengShu_survey.vue";
import motivMana from "./QuestionManagement/RC_motivation.vue";
import behavMana from "./QuestionManagement/RC_behavior.vue";
import resourMana from "./QuestionManagement/RC_resource.vue";
import jiankangMana from "./QuestionManagement/JianKang_survey.vue";
import tongdianMana from "./QuestionManagement/JianKang_PainSpot_Survey.vue";
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    created() {
        this.task_id = this.$route.query.taskid;
        this.task_name = this.$route.query.task_name;
        this.task_type = this.$route.query.type;
        if(this.$route.query.ass){
            this.assessee_name = this.$route.query.ass; 
        }else{
            this.assessee_name = '';
        }            
        this.assessee_id = this.$route.query.rid;
        if(this.task_type == "工作动机重要性及满意度评估" || this.task_type == "下属离职倾向识别" || this.task_type == "激励资源评估"){           
            this.status = this.$route.query.status;
            this.is_superior = this.$route.query.superior
            if(this.is_superior=='是' && this.assessee_name==''){
                this.assessee_name = '本人'
            }else if(this.is_superior=='否'){
                this.assessee_name = '上级'
            }
            if(this.task_type == '工作动机重要性及满意度评估'){
                if(this.status == '未开始'){
                    this.$nextTick(() => {
                        this.$refs.motiv_mana.getRCMotivation(this.task_id);
                    })
                }else{
                    this.$nextTick(() => {
                        this.$refs.motiv_mana.getRCMotivationResults(this.task_id, this.assessee_id);
                    })
                }     
            }else if(this.task_type == '激励资源评估'){
                if(this.status == '未开始'){
                    this.getRCResource(this.task_id);
                }else{
                    this.getRCResourceResults(this.task_id);
                }
            }else if(this.task_type == '下属离职倾向识别'){
                if(this.status == '未开始'){
                    this.getRCBehavior(this.task_id);
                }else{
                    this.getRCBehaviorResults(this.task_id);
                }
            }
        }else if(this.task_type == "组织健康度调研（A卷）" || this.task_type == "管理痛点调研（B卷）" || this.task_type == "管理痛点献计献策（C卷）" || this.task_type == '管理痛点调研（D卷）'){
            this.status = this.$route.query.status;
            this.ques_type = this.$route.query.ques;
            this.opt_type = this.$route.query.opt;
            this.login_random_series = this.$route.query.rid;
            this.submit_times = 0;
            if(this.task_type == '组织健康度调研（A卷）'){
                if(this.opt_type=='eval'){
                    this.getJKManaQues(this.task_id);
                }else{
                    this.getJKManaQues(this.task_id, 'view');
                }
            }else{
                if(this.opt_type=='eval'){
                    this.getTDManaQues(this.ques_type, this.task_id);
                }else{
                    this.getTDManaQues(this.ques_type, this.task_id, 'view');
                }
            }
        }else{
            this.opt_type = this.$route.query.opt;
            if(this.opt_type=='eval'){
                if(this.task_type == '管理痛点调研'){
                    this.getManaSurvey(this.task_id);
                }else{
                    this.getManaQues(this.task_id);
                } 
            }else{
                if(this.task_type == '管理痛点调研'){
                    this.getManaSurvey(this.task_id, 'view');
                }else{
                    this.getManaQues(this.task_id, 'view');
                }           
            }
        }    
    },
    components: {
        quesmana,
        surveyMana,
        motivMana,
        behavMana,
        resourMana,
        jiankangMana,
        tongdianMana,
    },
    data() {
        return {
            task_id: '',
            task_name: '',
            task_type: '',
            assessee_name: '',
            assessee_id: '',
            opt_type: '',
            task_list: [],
            form: {},
            dialogFormVisible: false,
            dialogFormVisible_survey: false,
            submit_question_info: [],
            submit_survey_info: [],
            submit_proof_info: [],
            qid_list: [],
            result_list: [],
            request_info: {},
            unfinish_num: 0,
            question_info: [],
            survey_info: [],
            proof_info: [],
            check_flag: true,
            error_flag: false,  //标识检查是否有错误，用于标红未答的主观题
            check_flag_survey: true,
            error_flag_survey: false,  //标识检查是否有错误，用于标红未答的主观题
            activeNames: [],
            behavior_info: [],
            resource_info: [],
            error_flag_resource: false,  //标识检查是否有错误，用于标红未答的主观题（激励资源问卷）
            status: '', 
            submit_status: false,   //提交成功后，修改标识，防止用户继续点击保存按钮
            ques_type: '',
            sys_params: {},
            selected_painspots: [],
            login_random_series: null,
            low_score_num: 0,
            continuous_num: 0,
            painspot_info: [],
            jk_question_info: [],
            jk_proof_info: [],
            timer: null,
            timer2: null,
            timer_flag: false,      // 定时器状态：false销毁定时器，true打开定时器
            show: false,
            submit_times: 0,        // 问卷提交次数，当次数>0时，表示问卷有问题提交失败，此时重选错误的题目可以触发重新检测
        };
    },
    methods: {
        start_interval(status) {
            if(status!='已提交'){
                this.timer_flag = true;     // 只在调研未完成的情况下才开启定时提交任务
            }else{
                this.timer_flag = false;
                return;
            }
            // let i = 0;
            this.timer = setInterval(() => {
                if(this.timer_flag==false) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                if(this.task_type == '组织健康度调研（A卷）') {
                    this.$refs.jiankang_mana.submitManaQues_timer();
                }else{
                    this.$refs.tongdian_mana.submitManaQues();
                }
            },10000)
        },
        clear_interval() {
            this.timer_flag = false;        //关闭对话框时，销毁定时任务
            clearInterval(this.timer);
            this.timer = null;
        },       
        dialogSubmit_jk() {
            this.$refs.jiankang_mana.submitManaQues();
        },
        dialogSubmit_ps() {
            this.$refs.tongdian_mana.submitManaQues();
        },
        dialogSave_rc() {
            if(this.task_type=='工作动机重要性及满意度评估'){
                this.$refs.motiv_mana.saveMotivation();
            }else if(this.task_type=='下属离职倾向识别') {
                this.$refs.behav_mana.saveBehavior();
            }else if(this.task_type=='激励资源评估') {
                this.$refs.resour_mana.saveResource();
            }
        },
        dialogSubmit_rc() {
            if(this.task_type=='工作动机重要性及满意度评估'){
                this.$refs.motiv_mana.submitMotivation();
            }else if(this.task_type=='下属离职倾向识别') {
                this.$refs.behav_mana.submitBehavior();
            }else if(this.task_type=='激励资源评估') {
                this.$refs.resour_mana.submitResource();
            }
        },
        goBack() {
            // Vue Router 方法
            this.$router.go(-1);
            // 或调用浏览器回退 API 
            // history.back(); 
        },
        getManaQues(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getManaQues", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.question_info = resp.data.choice;
                    this.proof_info = resp.data.proof;
                    // console.log("question_info: " + this.question_info);
                    // console.log("proof_info" + this.proof_info);
                    // 获取结果的处理需要放在成功获取到问卷之后，否则会触发获取结果早于获取问卷的情况，导致问卷中无结果信息
                    if(r != 'none_rows'){
                        this.getResultByUser(this.assessee_id, this.task_type, this.task_id);
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getRCBehavior(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getRCBehavior", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.behavior_info = resp.data.data;
                    // this.dialogFormVisible_behavior = true;
                    if(r != 'none_rows'){
                        this.getResultByUser(task_id);
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getRCResource(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getRCResource", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.resource_info = resp.data.data;
                    // this.dialogFormVisible_resource = true;
                    if(r != 'none_rows'){
                        this.getResultByUser(task_id);
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getJKManaQues(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getHealthSurvey", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.jk_question_info = resp.data.choice;
                    this.jk_proof_info = resp.data.proof;
                    this.low_score_num = resp.data.low_score_num;
                    this.continuous_num = resp.data.continuous_num;
                    // console.log("question_info: " + this.question_info);
                    // console.log("proof_info" + this.proof_info);
                    // 获取结果的处理需要放在成功获取到问卷之后，否则会触发获取结果早于获取问卷的情况，导致问卷中无结果信息
                    if(r != 'none_rows'){
                        this.getJKResultByUser(task_id);
                    }
                    this.start_interval(this.status);
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getTDManaQues(ques_type, task_id, row) {
            let r = row || 'none_rows';
            let params = {
                ques_type: ques_type,
                task_id: task_id,
            }
            if(r != 'none_rows'){
                params = {
                    login_random_series: this.login_random_series,
                    ques_type: ques_type,
                    task_id: task_id,
                }
            }
            getdata.getListP("getFullPainSpotSurvey", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.painspot_info = resp.data.data;
                    this.ques_type = ques_type;
                    this.sys_params = resp.data.sys_params;
                    this.selected_painspots = resp.data.selected_painspots;
                    // console.log("question_info: " + this.question_info);
                    // console.log("proof_info" + this.proof_info);
                    // 获取结果的处理需要放在成功获取到问卷之后，否则会触发获取结果早于获取问卷的情况，导致问卷中无结果信息
                    // if(r != 'none_rows'){
                    //     this.getResultByUser(ques_type, task_id);
                    // }
                    this.start_interval(this.status);
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getResultByUser(assessee_id, eval_type, task_id) {
            let params;
            params = {
                assessee_id: assessee_id,
                eval_type: eval_type,
                task_id: task_id,
            } 
            
            getdata.getListP("getManaResults", params)
            .then(resp => {
                if(resp.data.code == 200){
                    var result = resp.data.data;
                    // console.log('result: ' + result + ' ' + result[0]);
                    var i = 0; 
                    // 首先是选择题
                    for(var cg in this.question_info){
                        for(var scg in this.question_info[cg]['sub_category']){
                            for(var sj in this.question_info[cg]['sub_category'][scg]['subject']){
                                this.question_info[cg]['sub_category'][scg]['subject'][sj]['selected_option'] = result[i];
                                i = i + 1;
                            }
                        }
                    }
                    // console.log("question_info2: " + this.question_info);
                    // 然后是举证题
                    for(var pf in this.proof_info){
                        this.proof_info[pf]['proof'] = result[i];
                        i = i + 1;
                    }
                    // console.log("proof_info2: " + this.proof_info);
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getJKResultByUser(task_id) {
            let params;
            params = {
                login_random_series: this.login_random_series,
                task_id: task_id,
            } 
            
            getdata.getListP("getHealthSurveyResult", params)
            .then(resp => {
                if(resp.data.code == 200){
                    var result = resp.data.data;
                    // console.log('result: ' + result + ' ' + result[0]);
                    var i = 0; 
                    // 首先是选择题
                    for(var cg in this.jk_question_info){
                        for(var sj in this.jk_question_info[cg]['subject']){
                            this.jk_question_info[cg]['subject'][sj]['selected_option'] = result[i];
                            i = i + 1;
                        }
                    }
                    // console.log("question_info2: " + this.question_info);
                    // 然后是举证题
                    for(var pf in this.jk_proof_info){
                        this.jk_proof_info[pf]['proof'] = result[i];
                        i = i + 1;
                    }
                    // console.log("proof_info2: " + this.proof_info);
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        dialogCancel() {
            this.goBack();
        },
        dialogCancel_jk() {
            this.goBack();
        },
        dialogCancel_ps() {
            this.goBack();
        },
        // dialogCancel_survey() {
        //     this.dialogFormVisible_survey = false;
        // },
        dialogSubmit() {
            if(this.task_type=='管理痛点调研'){
                this.dialogSubmit_survey();
            }else{
                this.dialogSubmit_ques();
            }
        },
        dialogSubmit_ques() {
            this.$confirm('提交后将无法修改, 请确认是否提交?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 触发子组件的$emit方法向父组件传递数据
                this.$refs.ques_mana.submitManaQues();
                // 答题不完整，check_flag会被设置为false，则终止提交
                if(this.check_flag == false){
                    return;
                }
                // this.dialogFormVisible = false;
                // 提交问卷后，需要刷新当前评估人的评估状态数据，以及更新待处理评估数
                // this.getToDoList();
                // this.updateToDoNum();
            }).catch( err => {
                console.log(err);
            })
        },
        dialogSubmit_survey() {
            this.$confirm('提交后将无法修改, 请确认是否提交?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 触发子组件的$emit方法向父组件传递数据
                this.$refs.survey_mana.submitManaSurvey();
                // 答题不完整，check_flag会被设置为false，则终止提交
                if(this.check_flag == false){
                    return;
                }
                // this.dialogFormVisible_survey = false;
                // 提交问卷后，需要刷新当前评估人的评估状态数据，以及更新待处理评估数
                // this.getToDoList();
                // this.updateToDoNum();
            }).catch( err => {
                console.log(err);
            })
        },
        checkManaQues() {
            for(var cg in this.submit_question_info){
                for(var scg in this.submit_question_info[cg]['sub_category']){
                    for(var sj in this.submit_question_info[cg]['sub_category'][scg]['subject']){
                        if(this.submit_question_info[cg]['sub_category'][scg]['subject'][sj]['selected_option'] == ''){
                            this.$message({
                                message: '有未完成的答题，请检查！',
                                type: 'error',
                                duration: 6000,
                                // showClose: true,
                            })
                            this.check_flag = false;
                            this.error_flag = true;
                            console.log("this.error_flag: " + this.error_flag);
                            return;
                        }
                    }
                }
            }
            // 如果检查没问题，重新赋值check_flag为true
            this.check_flag = true;
            this.error_flag = false;
            console.log("this.error_flag: " + this.error_flag);
        },
        checkManaSurvey() {
            for(var i in this.submit_survey_info){
                if(this.submit_survey_info[i]['choice_type']=='多选' && this.submit_survey_info[i]['selected_option']=='其他'){
                    if(!this.submit_survey_info[i]['proof']){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        this.check_flag_survey = false;
                        this.error_flag_survey = true;
                        console.log("this.error_flag_survey: " + this.error_flag_survey);
                        return;
                    }
                }else{
                    if(this.submit_survey_info[i]['selected_option'] == ''){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        this.check_flag_survey = false;
                        this.error_flag_survey = true;
                        console.log("this.error_flag_survey: " + this.error_flag_survey);
                        return;
                    }
                }
            }
            // 如果检查没问题，重新赋值check_flag为true
            this.check_flag_survey = true;
            this.error_flag_survey = false;
        },
        // 父组件获取子组件传递的问卷结果信息
        getQuesResults(data) {
            // 处理问卷结果信息，并提交后台处理
            this.submit_question_info = data[0];
            // 提交问卷前，需要先检查是否有未完成的题目（主要是选择题）
            this.checkManaQues();
            if(this.check_flag == false){
                return;
            }
            // 每次提交记录前，需要重置qid_list和result_list，防止连续提交时数据累加导致结果错误
            this.qid_list = [];
            this.result_list = [];
            // console.log('getData: subject_desc_sub= ' + this.submit_question_info[0]['sub_category'][0]['subject'][0]['subject_desc_sub']);          
            for(var cg in this.submit_question_info){
                for(var scg in this.submit_question_info[cg]['sub_category']){
                    for(var sj in this.submit_question_info[cg]['sub_category'][scg]['subject']){
                        this.qid_list.push(this.submit_question_info[cg]['sub_category'][scg]['subject'][sj]['qid']);
                        this.result_list.push(this.submit_question_info[cg]['sub_category'][scg]['subject'][sj]['selected_option']);
                    }
                }
            }
            this.submit_proof_info = data[1];
            for(var pf in this.submit_proof_info){
                this.qid_list.push(this.submit_proof_info[pf]['qid']);
                this.result_list.push(this.submit_proof_info[pf]['proof']);
            }
            this.request_info['assessee_id'] = this.assessee_id;
            // this.request_info['company'] = this.form['company'];
            this.request_info['eval_type'] = this.task_type;
            this.request_info['task_id'] = this.task_id;
            this.request_info['qid_list'] = this.qid_list;
            this.request_info['result_list'] = this.result_list;
            postdata.postList("submitManaQues", JSON.stringify(this.request_info))
              .then(resp => {
                if(resp.data.code == 200){
                  this.$message({
                    message: resp.data.message,
                    type: "success",
                    })
                // 将关闭窗口改放到这里，超出连续值范围时，不会退出窗口重新答题，可以继续修改后重新提交
                //   this.dialogFormVisible = false;
                //   this.getToDoList();
                    this.goBack();
                }else{
                  this.$message({
                    message: resp.data.message,
                    type: "error",
                    duration: 6000,
                    // showClose: true,
                    })
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        getSurveyResults(data) {
            // 每次提交记录前，需要重置submit_survey_info，防止连续提交时数据累加导致结果错误
            this.submit_survey_info = [];
            for(var survey in data) {
                var survey_reslut = {};
                survey_reslut['assessee_id'] = this.assessee_id;
                survey_reslut['qid'] = data[survey].qid;
                survey_reslut['choice_type'] = data[survey].choice_type;
                survey_reslut['display_num'] = data[survey].display_num;
                survey_reslut['selected_option'] = data[survey].selected_option;
                survey_reslut['proof'] = data[survey].proof;
                survey_reslut['task_id'] = this.task_id;
                this.submit_survey_info.push(survey_reslut);
            }
            this.checkManaSurvey();
            if(this.check_flag_survey == false){
                return;
            }
            
            postdata.postList("submitManaSurvey", JSON.stringify(this.submit_survey_info))
              .then(resp => {
                if(resp.data.code == 200){
                  this.$message({
                    message: resp.data.message,
                    type: "success",
                    })
                //   this.dialogFormVisible_survey = false;
                //   this.getToDoList();
                    this.goBack();
                }else{
                  this.$message({
                    message: resp.data.message,
                    type: "error",
                    duration: 6000,
                    // showClose: true,
                    })
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        getRCBehaviorResults() {
            let params = {
                task_id: this.task_id,
                user_id: this.assessee_id, 
            }
            getdata.getListP("getBehaviorResults", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.behavior_info = resp.data.data;
                    // this.dialogFormVisible_behavior = true;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getRCResourceResults() {
            let params = {
                task_id: this.task_id,
                user_id: this.assessee_id, 
            }
            getdata.getListP("getResourceResults", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.resource_info = resp.data.data;
                    // this.dialogFormVisible_resource = true;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getJKQuesResults(data) {
            // 处理问卷结果信息，并提交后台处理
            this.submit_question_info = data[0];
            // 提交问卷前，需要先检查是否有未完成的题目（主要是选择题）---定时任务提交时不做检查
            // if(this.timer_flag==false){
            if(data[2]=='normal'){
                this.checkManaQues();
                if(this.check_flag == false){
                    return;
                }
            }
            // 每次提交记录前，需要重置qid_list和result_list，防止连续提交时数据累加导致结果错误
            this.qid_list = [];
            this.result_list = [];
            let dimension_result = {};  // 增加按照维度统计结果
            // console.log('getData: subject_desc_sub= ' + this.submit_question_info[0]['sub_category'][0]['subject'][0]['subject_desc_sub']);          
            for(var cg in this.submit_question_info){
                dimension_result[this.submit_question_info[cg]['category']] = [];
                for(var sj in this.submit_question_info[cg]['subject']){
                    this.qid_list.push(this.submit_question_info[cg]['subject'][sj]['qid']);
                    this.result_list.push(this.submit_question_info[cg]['subject'][sj]['selected_option']);
                    dimension_result[this.submit_question_info[cg]['category']].push(this.submit_question_info[cg]['subject'][sj]['selected_option'])
                }
            }
            this.submit_proof_info = data[1];
            for(var pf in this.submit_proof_info){
                this.qid_list.push(this.submit_proof_info[pf]['qid']);
                this.result_list.push(this.submit_proof_info[pf]['proof']);
            }
            this.request_info['login_random_series'] = this.login_random_series;
            this.request_info['task_id'] = this.task_id;
            this.request_info['qid_list'] = this.qid_list;
            this.request_info['result_list'] = this.result_list;
            this.request_info['dimension_result'] = dimension_result;
            // if(this.timer_flag==false){
            if(data[2]=='normal'||data[2]=='modify_check'){
                this.request_info['is_user_submit'] = 1;    // 1：标识该内容时用户提交的，非自动提交的
            }else{
                this.request_info['is_user_submit'] = 0;    //定时任务提交时，标识为0
            }
            postdata.postList("submitHealthSurvey", JSON.stringify(this.request_info))
              .then(resp => {
                // if(this.timer_flag==false){     // 定时任务提交时不做结果识别处理
                if(data[2]=='normal'||data[2]=='modify_check'){
                    if(resp.data.code == 200){
                        if(data[2]=='normal') {
                            this.$message({
                                message: resp.data.message,
                                type: "success",
                            })
                            // 提交成功时才进行销毁定时任务
                            this.timer_flag = false;        //点击按钮提交问卷成功时，同样销毁定时任务
                            clearInterval(this.timer);
                            this.timer = null;
                            // 将关闭窗口改放到这里，超出连续值范围时，不会退出窗口重新答题，可以继续修改后重新提交
                            this.dialogFormVisible = false;
                            this.getToDoList();
                        }
                    }else{
                        // 增加优化，除了提示错误信息，还针对性地对不符合要求的选项标红处理
                        if(resp.data.code == -3){
                            this.submit_times = 1;
                            // 连续值选项超限
                            this.$refs.survey_mana.update_error_info(resp.data.continuous_error_list, resp.data.low_score_error_list);
                        }else if(resp.data.code == -5){
                            this.submit_times = 1;
                            // 高得分选项超限
                            this.$refs.survey_mana.update_error_info(resp.data.continuous_error_list, resp.data.low_score_error_list);
                        }
                        if(data[2]=='normal') {
                            this.$message({
                                message: resp.data.message,
                                type: "error",
                                duration: 6000,
                                // showClose: true,
                            })
                        }
                    }
                }else{
                    // 这里改为文字淡入淡出显示 数据已自动保存
                    // this.show = true;
                    this.$message({
                        message: '数据已自动保存！',
                    })
                    // this.timer2 = setTimeout(() => {
                    //     this.show = false;
                    // }, 3000);
                    // this.timer2 = null;
                    // clearTimeout(this.timer2);
                    // this.$message({
                    //     message: "数据已自动保存",
                    //     type: "info",
                    //     duration: 1000,
                    //     // showClose: true,
                    // })
                    // this.getToDoList();
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        getTDQuesResults(data) {
            // 处理问卷结果信息，并提交后台处理
            this.request_info['login_random_series'] = this.login_random_series;
            this.request_info['task_id'] = this.task_id;
            this.request_info['ques_type'] = this.ques_type;
            this.request_info['result_list'] = data[0];
            this.request_info['selected_painspots'] = data[1];
            // 20231224 增加对未答题场景的判定
            if(this.timer_flag==false){
                if(data[2] == 'B' || data[2] == 'D'){
                    if(this.request_info['selected_painspots'].length == 0){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        return;
                    }
                }else{
                    // 问卷C需要分别检查每个TOP痛点的文字题和选择题的答题情况
                    var ques_c_check = false;
                    for(var i in data[0]){
                        if(data[0][i].phenomenon || data[0][i].selected_causes.length > 0 || data[0][i].done_measures && data[0][i].expect_measures || data[0][i].future_measures){
                            ques_c_check = true;
                            break;
                        }
                    }
                    if(ques_c_check == false){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        return;
                    }
                }
                
            }
            
            if(this.timer_flag==false){
                this.request_info['is_user_submit'] = 1;    // 1：标识该内容时用户提交的，非自动提交的
            }else{
                this.request_info['is_user_submit'] = 0;    //定时任务提交时，标识为0
            }
            postdata.postList("submitFullPainSpotSurvey", JSON.stringify(this.request_info))
              .then(resp => {
                if(this.timer_flag==false){     // 定时任务提交时不做结果识别处理
                    if(resp.data.code == 200){
                        this.$message({
                            message: resp.data.message,
                            type: "success",
                        })
                        // 将关闭窗口改放到这里，超出连续值范围时，不会退出窗口重新答题，可以继续修改后重新提交
                        this.dialogFormVisible = false;
                        this.getToDoList();
                    }else{
                        this.$message({
                            message: resp.data.message,
                            type: "error",
                            duration: 6000,
                            // showClose: true,
                        })
                    }
                }else{
                    // 这里改为文字淡入淡出显示 数据已自动保存
                    this.$message({
                        message: '数据已自动保存！',
                    })
                    // this.show = true;
                    // this.timer2 = setTimeout(() => {
                    //     this.show = false;
                    // }, 3000);
                    // this.timer2 = null;
                    // clearTimeout(this.timer2);
                    // 不知道为啥，提交后selected_painspots就置空了，这里使用临时规避方法处理下
                    this.selected_painspots = data[1];
                    // this.$message({
                    //     message: "数据已自动保存",
                    //     type: "info",
                    //     duration: 1000,
                    //     // showClose: true,
                    // })
                    // this.getToDoList();
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        submitMotivationResults(data) {
            if(data[4] == false){
                this.$message({
                    message: '勾选项数量与要求的数量不一致，请检查！',
                    type: 'error',
                    duration: 6000,
                    // showClose: true,
                })
            }else{
                // 处理问卷结果信息，并提交后台处理
                // 提交问卷前，需要先检查是否有未完成的题目（主要是选择题）---定时任务提交时不做检查
                // if(this.timer_flag==false){
                let save_mode = 'save';
                let submit_data = {'motivation_info': data[0]};
                submit_data['relatively_dissatisfied_motivations'] = data[2];
                submit_data['very_important_motivations'] = data[3];
                let api_name = "saveMotivationResults";
                if(data[1]=='submit'){
                    save_mode = 'submit';
                    // 检查待补充
                    // this.checkManaQues();
                    // if(this.check_flag == false){
                    //     return;
                    // }
                }
                let params = {
                    'task_id': this.task_id,
                    'save_mode': save_mode,
                    'user_id': this.assessee_id,
                };
                postdata.postListP(api_name, JSON.stringify(submit_data), params)
                .then(resp => {
                    if(resp.data.code == 200){
                        if(save_mode == 'save'){
                            this.$message({
                            message: '保存成功！',
                            type: "success",
                            })
                            this.form['status'] = '进行中';                   
                        }else{
                            this.$message({
                            message: '提交成功！',
                            type: "success",
                            })
                            this.getToDoList();
                            // this.dialogFormVisible = false;
                            this.submit_status = true;
                            this.goBack();
                        }                    
                    }
                })
                .catch(err => {
                    console.log(err);
                })
            }
        },
        submitBehaviorResults(data) {
            let save_mode = 'save';
            let api_name = "saveBehaviorResults";
            if(data[1]=='submit'){
                save_mode = 'submit';
                // 检查未填项
                this.error_flag = false;
                for(var i in data[0]){
                    if(data[0][i]['selected_option'] == ''){
                        this.error_flag = true;
                        this.$message({
                        message: '有未完成的答题，请检查！',
                        type: 'error',
                        duration: 6000,
                        })
                        return;
                    }
                }
            }
            let params = {
                'task_id': this.task_id,
                'save_mode': save_mode,
                'user_id': this.assessee_id,
            };
            postdata.postListP(api_name, JSON.stringify(data[0]), params)
              .then(resp => {
                if(resp.data.code == 200){
                    if(save_mode == 'save'){
                        this.$message({
                        message: '保存成功！',
                        type: "success",
                        })
                        this.form['status'] = '进行中';                   
                    }else{
                        this.$message({
                        message: '提交成功！',
                        type: "success",
                        })
                        this.getToDoList();
                        // this.dialogFormVisible_behavior = false;
                        this.submit_status = true;
                        this.goBack();
                    }                    
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        submitResourceResults(data) {
            let save_mode = 'save';
            let api_name = "saveResourceResults";
            if(data[1]=='submit'){
                save_mode = 'submit';
                // 检查未填项
                this.error_flag_resource = false;
                for(var i in data[0]){
                    if(data[0][i]['freq'] == ''){
                        this.error_flag_resource = true;
                        this.$message({
                        message: '有未完成的答题，请检查！',
                        type: 'error',
                        duration: 6000,
                        })
                        return;
                    }
                }
            }
            let params = {
                'task_id': this.task_id,
                'save_mode': save_mode,
                'user_id': this.assessee_id,
            };
            postdata.postListP(api_name, JSON.stringify(data[0]), params)
              .then(resp => {
                if(resp.data.code == 200){
                    if(save_mode == 'save'){
                        this.$message({
                        message: '保存成功！',
                        type: "success",
                        })
                        this.form['status'] = '进行中';                   
                    }else{
                        this.$message({
                        message: '提交成功！',
                        type: "success",
                        })
                        this.getToDoList();
                        // this.dialogFormVisible_resource = false;
                        this.submit_status = true;
                        this.goBack();
                    }                   
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        updateToDoNum() {
            // console.log('updateToDoNum-unfinish_num: ' + this.unfinish_num);
            this.$emit('sendToDoNum', this.unfinish_num);
        },
        getToDoList() {
            getdata.getList("getToDoList")
                .then(resp => {
                    if(resp.data.code == 200){
                        this.task_list = resp.data.data;
                        this.unfinish_num = resp.data.unfinish_num;
                        // 获取到未完成评测数后，同步给父组件
                        this.updateToDoNum();
                        this.activeNames = this.task_list.map((_, index) => index);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getManaSurvey(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getManaSurvey", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.survey_info = resp.data.survey_info;
                    // console.log("survey_info: " + this.survey_info);
                    // 获取结果的处理需要放在成功获取到问卷之后，否则会触发获取结果早于获取问卷的情况，导致问卷中无结果信息
                    if(r != 'none_rows'){
                        this.getResultByUser_survey(this.assessee_id, this.task_id);  
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getResultByUser_survey(assessee_id, task_id) {
            let params;
            params = {
                assessee_id: assessee_id,
                task_id: task_id,
            } 
            
            getdata.getListP("getManaSurveyResults", params)
            .then(resp => {
                if(resp.data.code == 200){
                    let results = resp.data.data;
                    for(var survey in results) {
                        this.survey_info[survey]['assessee_id'] = results[survey]['assessee_id'];
                        this.survey_info[survey]['qid'] = results[survey]['qid'];
                        this.survey_info[survey]['choice_type'] = results[survey]['choice_type'];
                        this.survey_info[survey]['display_num'] = results[survey]['display_num'];
                        this.survey_info[survey]['selected_option'] = results[survey]['selected_option'];
                        this.survey_info[survey]['proof'] = results[survey]['proof'];
                        this.survey_info[survey]['task_id'] = results[survey]['task_id'];
                    }
                    // console.log("survey_info2: " + this.survey_info);
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
    }
}
</script>

<style scoped>
::v-deep .el-button {
  padding: 10px 23px;
  border-radius: 5px;
  font-size: 12px;
  background-color: #f8f8f8;
  border-color: #cccccc;
  color: #000000;
}
::v-deep .el-button--primary {
  background-color: #42b6ff;
  border-color: #42b6ff;
  color: #ffffff;
}
.el-button[disabled], .el-button.is-disabled {
  background-color: #C0C4CC !important;  /* 禁用态-背景灰（和Element默认一致） */
  border-color: #C0C4CC !important;      /* 禁用态-边框灰（和Element默认一致） */
  color: #FFF !important;                /* 禁用态-文字白（和Element默认一致） */
  cursor: not-allowed !important;        /* 禁用态-鼠标禁止样式（必加） */
  opacity: 0.6 !important;               /* 透明度降低，视觉置灰更明显（推荐加） */
}
</style>